const items = [
  'Luxury Home Buyers',
  'Sellers',
  'Investors',
  'Second-Home Owners',
  '★★★★★ Trusted in Lake Tahoe & Sierra Nevada',
  'Local Expertise',
  'High-Value Transactions',
  'Personalized Representation',
  'Alpine & Resort Specialists',
  'Precision-Driven Results',
];

export default function TrustBar() {
  return (
    <section className="relative z-20 bg-charcoal border-y border-gold/15 py-6 overflow-hidden">
      {/* Subtle gold line top */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
      <div className="flex items-center gap-0 trust-marquee">
        {[...items, ...items].map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-6 whitespace-nowrap text-warm-white/65 text-[10px] tracking-[0.25em] uppercase font-light px-8"
          >
            {item}
            <span className="text-gold/50 text-xs">◆</span>
          </span>
        ))}
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
      <style>{`
        .trust-marquee {
          display: flex;
          animation: marquee 35s linear infinite;
        }
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}